import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getCreditCardApplicationReport: (params: ParamsModel = {page: 1, limit: 15}) => ({
    type: actionTypes.GET_CREDIT_CARD_APPLICATION_REPORT_START,
    payload: params,
  }),
  getCreditCardApplicationReportSuccess: (data: any) => ({
    type: actionTypes.GET_CREDIT_CARD_APPLICATION_REPORT_SUCCESS,
    payload: data,
  }),
  getCreditCardApplicationReportFinish: () => ({
    type: actionTypes.GET_CREDIT_CARD_APPLICATION_REPORT_FINISH,
  }),
}
